import { render, staticRenderFns } from "./ReportPublishSettings.vue?vue&type=template&id=ddddc5ea&scoped=true"
import script from "./ReportPublishSettings.vue?vue&type=script&lang=js"
export * from "./ReportPublishSettings.vue?vue&type=script&lang=js"
import style0 from "./ReportPublishSettings.vue?vue&type=style&index=0&id=ddddc5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddddc5ea",
  null
  
)

export default component.exports